import { alpha, Box, Drawer, styled } from "@mui/material";
import { keyframes, css } from "@emotion/react";

// Define the spin keyframes
const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

export const UpshotloaderContainer = styled(Box)(
  ({ theme }) => css`
    background-color: ${theme.palette.common.white};

    .loaderoverlay {
      position: fixed;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      z-index: 20006;
      background-color: rgba(0, 0, 0, 0.8);
      transition: all 0.3s;
      -webkit-transition: all 0.3s;
      -moz-transition: all 0.3s;
      -o-transition: all 0.3s;
    }

    .Next-loader {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 20010;

      .Lspinner {
        width: 100px;
        height: 100px;
        border: 3px solid #fff;
        border-radius: 50%;
        border-left-color: transparent !important;
        border-right-color: transparent !important;
        border-bottom-color: #fff !important;
        border-top-color: #fff !important;
        margin-top: -50px;
        margin-left: -50px;
        position: absolute;
        top: 50%;
        left: 50%;
        background: transparent !important;
        -webkit-animation: ${spin} 1s linear infinite;
        -moz-animation: ${spin} 1s linear infinite;
        animation: ${spin} 1s linear infinite;
      }

      .loaderBrand {
        text-align: center;
        position: relative;
        top: 50%;
        -webkit-transform: translateY(-50%);
        -moz-transform: translateY(-50%);
        -ms-transform: translateY(-50%);
        -o-transform: translateY(-50%);
        transform: translateY(-50%);
      }
    }
  `
);
